export default __webpack_public_path__ + "static/media/Accouncements-MERGED.c3930ac3.png";